import HoverContentActionsLib from './HoverContentActionsLib';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HoverContentIndex(props) {
  return /*#__PURE__*/_jsx(HoverContentActionsLib, {
    crmObject: props.crmObject
  });
}